import React, { useState } from "react";
import { Card, Table, Tag, Typography, Button } from "antd";
import { DesktopOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { cardStyle } from "../styles";
import AssetDetailDrawer from "../../../Assets/AssetDetailDrawer";

const { Text } = Typography;

const columns = (onView) => [
  {
    title: "Tên tài sản",
    dataIndex: "name",
    key: "name",
    width: 200,
    fixed: 'left',
    render: (text) => <Text strong>{text}</Text>,
  },
  {
    title: "Mã tài sản",
    dataIndex: "code",
    key: "code",
    width: 150,
    render: (code) => <Tag color="blue">{code}</Tag>,
  },
  {
    title: "Đơn vị",
    dataIndex: "organization_name",
    key: "organization_name",
    width: 200,
    render: (_, record) => (
      <Tag color="geekblue">
        {record?.organization?.name || "-"}
      </Tag>
    ),
  },
  {
    title: "Chủ hộ",
    dataIndex: "representative_name",
    key: "representative_name",
    width: 180,
    render: (text) => text || "-",
  },
  {
    title: "SĐT chủ hộ",
    dataIndex: "representative_phone",
    key: "representative_phone",
    width: 150,
    render: (text) => text || "-",
  },
  {
    title: "Trạng thái",
    dataIndex: "status",
    key: "status",
    width: 150,
    render: (status) => (
      <Tag color={status ? "green" : "red"}>
        {status ? "Hoạt động" : "Không hoạt động"}
      </Tag>
    ),
  },
  {
    title: "Thao tác",
    key: "actions",
    width: 100,
    align: "center",
    fixed: "right",
    render: (_, record) => (
      <Button
        type="text"
        size="small"
        icon={<InfoCircleOutlined />}
        onClick={() => onView(record.id)}
        title="Xem chi tiết"
      />
    ),
  },
];

export default function AssetListTable({ assets }) {
  // Xem chi tiết tài sản ngay tại chỗ, không rời màn chi tiết khách hàng
  const [detailOpen, setDetailOpen] = useState(false);
  const [detailId, setDetailId] = useState(null);

  const handleView = (id) => {
    setDetailId(id);
    setDetailOpen(true);
  };

  return (
    <Card
      title={
        <>
          <DesktopOutlined style={{ marginRight: 8 }} />
          Danh sách tài sản hiện tại
        </>
      }
      style={{ ...cardStyle, marginTop: 24 }}
    >
      <Table
        columns={columns(handleView)}
        dataSource={assets || []}
        rowKey="id"
        pagination={false}
        scroll={{ x: "max-content" }}
        size="small"
        locale={{ emptyText: "Không có tài sản nào" }}
      />

      <AssetDetailDrawer
        open={detailOpen}
        assetId={detailId}
        onClose={() => setDetailOpen(false)}
      />
    </Card>
  );
}
